"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MeasureReport = exports.MeasureReportTypeKind = exports.MeasureReportStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_MeasureReport_Group_1 = require("./RTTI_MeasureReport_Group");
var MeasureReportStatusKind;
(function (MeasureReportStatusKind) {
    MeasureReportStatusKind["_complete"] = "complete";
    MeasureReportStatusKind["_pending"] = "pending";
    MeasureReportStatusKind["_error"] = "error";
})(MeasureReportStatusKind = exports.MeasureReportStatusKind || (exports.MeasureReportStatusKind = {}));
var MeasureReportTypeKind;
(function (MeasureReportTypeKind) {
    MeasureReportTypeKind["_individual"] = "individual";
    MeasureReportTypeKind["_subjectList"] = "subject-list";
    MeasureReportTypeKind["_summary"] = "summary";
    MeasureReportTypeKind["_dataCollection"] = "data-collection";
})(MeasureReportTypeKind = exports.MeasureReportTypeKind || (exports.MeasureReportTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_MeasureReport = t.recursion('IMeasureReport', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('MeasureReport'),
            measure: RTTI_canonical_1.RTTI_canonical,
            period: RTTI_Period_1.RTTI_Period
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            status: (0, EnumType_1.createEnumType)(MeasureReportStatusKind, 'MeasureReportStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            type: (0, EnumType_1.createEnumType)(MeasureReportTypeKind, 'MeasureReportTypeKind'),
            _type: RTTI_Element_1.RTTI_Element,
            subject: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            reporter: RTTI_Reference_1.RTTI_Reference,
            improvementNotation: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            group: t.array(RTTI_MeasureReport_Group_1.RTTI_MeasureReport_Group),
            evaluatedResource: t.array(RTTI_Reference_1.RTTI_Reference)
        })
    ]);
});
//# sourceMappingURL=RTTI_MeasureReport.js.map